"use strict";

var _slicedToArray = require("/codebuild/output/src490952806/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _defineProperty = require("/codebuild/output/src490952806/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _ArrowForward = _interopRequireDefault(require("@material-ui/icons/ArrowForward"));
var _breakpoints = _interopRequireDefault(require("../config/breakpoints"));
var _HeaderContactUs = _interopRequireDefault(require("./HeaderContactUs"));
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var CompanyLogo = (0, _helpers.getImageByAgent)('companyLogo.svg');
var WhatsappLogo = (0, _helpers.getImageByAgent)('whatsapp-logo.svg');
var EmailLogo = (0, _helpers.getImageByAgent)('Email_Icon.svg');
var THANK_YOU_MESSAGE_TIMEOUT = 3 * 1000;
var MOBILE_HEADER_HEIGHT = 48;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _leftBtnsMobile;
  return {
    desktop: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between'
    },
    emailIcon: {
      marginLeft: '10px',
      width: 35
    },
    labeledBtn: {
      /* applies for back & chat: */
      '& > .MuiButton-label': {
        flexDirection: 'column'
      },
      '& img': {
        width: 27
      },
      '& span': {
        fontFamily: 'Ploni,Arial,sans-serif',
        fontSize: '.8rem',
        fontWeight: 600,
        lineHeight: '.8rem'
      },
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.primary.main
      },
      alignItems: 'center',
      boxSizing: 'content-box',
      color: theme.palette.secondary.main,
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      fontSize: theme.typography.pxToRem(22.75),
      height: 'inherit',
      justifyContent: 'center',
      letterSpacing: '.0163em',
      minWidth: 32,
      padding: 0,
      textDecoration: 'none'
    },
    leftBtnsDesktop: {
      '& > *': {
        marginLeft: 18
      },
      alignItems: 'center',
      display: 'flex'
    },
    leftBtnsMobile: (_leftBtnsMobile = {
      alignItems: 'center',
      display: 'flex',
      flex: '1 1 auto',
      flexFlow: 'row nowrap',
      height: MOBILE_HEADER_HEIGHT,
      justifyContent: 'space-between'
    }, _defineProperty(_leftBtnsMobile, theme.breakpoints.up(420), {
      maxWidth: 290
    }), _defineProperty(_leftBtnsMobile, theme.breakpoints.down('md'), {
      '& a, & div': {
        marginLeft: 10
      },
      flex: '1 0 auto'
    }), _leftBtnsMobile),
    logo: _defineProperty({
      '& svg': {
        height: '100%'
      },
      height: 50,
      position: 'absolute'
    }, theme.breakpoints.down(_breakpoints.default.mobile), {
      height: 26,
      position: 'static'
    }),
    mobile: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: '0px 2px 2px #00000017',
      display: 'flex',
      flexFlow: 'row nowrap',
      height: MOBILE_HEADER_HEIGHT,
      justifyContent: 'space-between',
      left: 0,
      padding: '0 20px',
      position: function position(props) {
        return props.isHeaderFixed ? 'fixed' : 'relative';
      },
      top: 0,
      width: '100%',
      zIndex: 10000
    },
    mobileContainer: {
      paddingTop: function paddingTop(props) {
        return props.isHeaderFixed ? MOBILE_HEADER_HEIGHT : 0;
      }
    },
    open: {
      pointerEvents: 'all',
      touchAction: 'auto',
      zIndex: 1
    },
    ourEmail: _defineProperty({
      '& > span': {
        fontSize: 24,
        height: 30,
        paddingLeft: 2
      },
      '&:hover': {
        color: theme.palette.primary.main
      },
      alignItems: 'center',
      color: theme.palette.secondary.main,
      display: 'flex',
      flexDirection: 'row-reverse',
      fontSize: theme.typography.pxToRem(27),
      fontWeight: 'bold',
      textDecoration: 'none'
    }, theme.breakpoints.down(_breakpoints.default.mobile), {
      fontSize: theme.typography.pxToRem(16)
    }),
    ourNumber: _defineProperty({
      '& > span': {
        fontSize: 24,
        height: 30,
        paddingLeft: 2
      },
      '&:hover': {
        color: theme.palette.primary.main
      },
      alignItems: 'center',
      color: theme.palette.secondary.main,
      display: 'flex',
      fontSize: theme.typography.pxToRem(27),
      fontWeight: 'bold',
      textDecoration: 'none'
    }, theme.breakpoints.down(_breakpoints.default.mobile), {
      fontSize: theme.typography.pxToRem(16)
    }),
    rightBtnsDesktop: {
      '& svg': {
        display: 'block',
        height: '100%'
      }
    },
    rightBtnsMobile: {
      height: MOBILE_HEADER_HEIGHT
    },
    submitButton: {
      fontSize: theme.typography.fontSize,
      fontWeight: 'bold',
      height: 53.63,
      width: '100%'
    }
  };
});
var Header = function Header(_ref) {
  var handler = _ref.handler,
    backFunction = _ref.backFunction,
    _ref$hasBackButton = _ref.hasBackButton,
    hasBackButton = _ref$hasBackButton === void 0 ? true : _ref$hasBackButton,
    _ref$hasContactus = _ref.hasContactus,
    hasContactus = _ref$hasContactus === void 0 ? true : _ref$hasContactus,
    _ref$hasChatButton = _ref.hasChatButton,
    hasChatButton = _ref$hasChatButton === void 0 ? false : _ref$hasChatButton,
    _ref$hasPhoneNumber = _ref.hasPhoneNumber,
    hasPhoneNumber = _ref$hasPhoneNumber === void 0 ? true : _ref$hasPhoneNumber,
    callHandler = _ref.callHandler,
    logoHandler = _ref.logoHandler,
    chatHandler = _ref.chatHandler,
    headerContactHandler = _ref.headerContactHandler,
    _ref$onCallMeClick = _ref.onCallMeClick,
    onCallMeClick = _ref$onCallMeClick === void 0 ? function () {} : _ref$onCallMeClick,
    phoneNumber = _ref.phoneNumber,
    isHeaderFixed = _ref.isHeaderFixed,
    hasEmail = _ref.hasEmail;
  var classes = useStyles({
    isHeaderFixed: isHeaderFixed
  });
  var _react$default$useSta = _react.default.useState(false),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    open = _react$default$useSta2[0],
    setOpen = _react$default$useSta2[1];
  var _react$default$useSta3 = _react.default.useState(false),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    contactWasSent = _react$default$useSta4[0],
    setContactWasSent = _react$default$useSta4[1];
  var _react$default$useSta5 = _react.default.useState(false),
    _react$default$useSta6 = _slicedToArray(_react$default$useSta5, 2),
    isLoading = _react$default$useSta6[0],
    setLoading = _react$default$useSta6[1];
  var isMobile = (0, _useMediaQuery.default)("(max-width:".concat(_breakpoints.default.mobile, "px)"));
  var handleClick = function handleClick() {
    if (headerContactHandler) {
      headerContactHandler();
    }
    var userData = onCallMeClick();
    var _ref2 = userData || {},
      firstname = _ref2.firstname,
      lastname = _ref2.lastname,
      phone = _ref2.phone;
    if (firstname && lastname && phone) {
      handleSubmit({
        fullname: "".concat(firstname, " ").concat(lastname),
        phone: phone
      }).then(function () {
        return setOpen(!open);
      });
    } else {
      setOpen(!open);
    }
  };
  var handleSubmit = function handleSubmit(values) {
    setLoading(true);
    return handler(values).then(function () {
      setContactWasSent(true);
      setLoading(false);
      setTimeout(function () {
        handleClose();
        setContactWasSent(false);
      }, THANK_YOU_MESSAGE_TIMEOUT);
    });
  };
  var handleClose = function handleClose() {
    setOpen(false);
  };
  var handleCallOnClick = function handleCallOnClick() {
    if (callHandler) {
      callHandler();
    }
  };
  var handleLogoOnClick = function handleLogoOnClick() {
    if (logoHandler) {
      logoHandler();
    }
  };
  var handleChatOnClick = function handleChatOnClick() {
    if (chatHandler) {
      chatHandler();
    }
  };
  var getWebSiteLogo = function getWebSiteLogo() {
    var agentName = _helpers.agentDeveloperUtils.agentData.Agent_Developer_Name_c;
    return /*#__PURE__*/_react.default.createElement("img", {
      src: CompanyLogo,
      className: classes.logo,
      alt: "".concat(agentName, " logo")
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: isMobile ? classes.mobileContainer : ''
  }, isMobile ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.mobile
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.rightBtnsMobile
  }, hasBackButton && backFunction ? /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: 'text',
    size: "small",
    className: "".concat(classes.labeledBtn, " ").concat(classes.back),
    onClick: backFunction
  }, /*#__PURE__*/_react.default.createElement(_ArrowForward.default, null), /*#__PURE__*/_react.default.createElement("span", null, "\u05D7\u05D6\u05D5\u05E8")) : ''), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.leftBtnsMobile
  }, hasChatButton ? /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    rel: "noreferrer",
    href: "https://wa.me/".concat(_helpers.agentDeveloperUtils.getWhatsappNumber),
    className: "".concat(classes.labeledBtn, " ").concat(classes.chat),
    onClick: handleChatOnClick
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: WhatsappLogo,
    alt: "\u05E6\u05F3\u05D0\u05D8 \u05E2\u05DD \u05DE\u05D5\u05E7\u05D3 ".concat(_helpers.agentDeveloperUtils.getAgentDisplayName, " \u05DC\u05EA\u05DE\u05D9\u05DB\u05D4 \u05D1\u05DB\u05DC \u05E0\u05D5\u05E9\u05D0")
  }), /*#__PURE__*/_react.default.createElement("span", {
    role: "presentation",
    "aria-hidden": true
  }, "\u05E6\u05F3\u05D0\u05D8")) : '', hasContactus ? /*#__PURE__*/_react.default.createElement(_HeaderContactUs.default, {
    open: open,
    isLoading: isLoading,
    handleClick: handleClick,
    handleClose: handleClose,
    handleSubmit: handleSubmit,
    contactWasSent: contactWasSent
  }) : null, hasPhoneNumber ? /*#__PURE__*/_react.default.createElement("a", {
    href: "tel:".concat(phoneNumber || '*2744'),
    "aria-label": "\u05DE\u05D5\u05E7\u05D3 ".concat(_helpers.agentDeveloperUtils.getAgentDisplayName, " \u05D1\u05D8\u05DC\u05E4\u05D5\u05DF *2744"),
    className: classes.ourNumber,
    onClick: handleCallOnClick
  }, "2744", /*#__PURE__*/_react.default.createElement("span", null, "*")) : null, /*#__PURE__*/_react.default.createElement("a", {
    title: _helpers.agentDeveloperUtils.websiteConfig.headerIconTooltip,
    href: _helpers.agentDeveloperUtils.getAgentLinks.website,
    onClick: handleLogoOnClick,
    className: classes.logo
  }, getWebSiteLogo()))) : /*#__PURE__*/_react.default.createElement("div", {
    className: classes.desktop
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.rightBtnsDesktop
  }, /*#__PURE__*/_react.default.createElement("a", {
    title: _helpers.agentDeveloperUtils.websiteConfig.headerIconTooltip,
    href: _helpers.agentDeveloperUtils.getAgentLinks.website,
    onClick: handleLogoOnClick
  }, getWebSiteLogo())), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.leftBtnsDesktop
  }, hasEmail ? /*#__PURE__*/_react.default.createElement("a", {
    href: "mailto:".concat(hasEmail),
    className: classes.ourEmail,
    "aria-label": "\u05E7\u05D9\u05E9\u05D5\u05E8 \u05DC\u05DE\u05D9\u05D9\u05DC \u05E9\u05DC\u05E0\u05D5 ".concat(hasEmail),
    onClick: handleCallOnClick
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: classes.emailIcon,
    src: EmailLogo,
    alt: "\u05DC\u05EA\u05DE\u05D9\u05DB\u05D4 \u05D1\u05DB\u05DC \u05E0\u05D5\u05E9\u05D0 \u05E2\u05DD \u05E0\u05E6\u05D9\u05D2 \u05E9\u05DC Wobi \u05D1\u05DE\u05D9\u05D9\u05DC"
  }), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: hasEmail
  }, /*#__PURE__*/_react.default.createElement("span", {
    role: "presentation",
    "aria-hidden": true
  }, hasEmail))) : null, hasChatButton ? /*#__PURE__*/_react.default.createElement("a", {
    href: 'https://wa.me/9720506565902',
    target: "_blank",
    rel: "noreferrer",
    className: "".concat(classes.labeledBtn, " ").concat(classes.chat),
    onClick: handleChatOnClick
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: WhatsappLogo,
    alt: "\u05E6\u05F3\u05D0\u05D8 \u05E2\u05DD \u05DE\u05D5\u05E7\u05D3 wobi \u05DC\u05EA\u05DE\u05D9\u05DB\u05D4 \u05D1\u05DB\u05DC \u05E0\u05D5\u05E9\u05D0"
  }), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: '050-6565902'
  }, /*#__PURE__*/_react.default.createElement("span", {
    role: "presentation",
    "aria-hidden": true
  }, "\u05E6\u05F3\u05D0\u05D8"))) : '', hasContactus ? /*#__PURE__*/_react.default.createElement(_HeaderContactUs.default, {
    open: open,
    isLoading: isLoading,
    handleClick: handleClick,
    handleClose: handleClose,
    handleSubmit: handleSubmit,
    contactWasSent: contactWasSent
  }) : null)));
};
Header.propTypes = {
  backFunction: _propTypes.default.func.isRequired,
  callHandler: _propTypes.default.func,
  chatHandler: _propTypes.default.func,
  handler: _propTypes.default.func.isRequired,
  hasBackButton: _propTypes.default.bool,
  hasChatButton: _propTypes.default.bool,
  hasContactus: _propTypes.default.bool,
  hasEmail: _propTypes.default.string,
  hasPhoneNumber: _propTypes.default.bool,
  headerContactHandler: _propTypes.default.func,
  isHeaderFixed: _propTypes.default.bool,
  logoHandler: _propTypes.default.func,
  onCallMeClick: _propTypes.default.func,
  phoneNumber: _propTypes.default.string
};
var _default = exports.default = Header;